export default __webpack_public_path__ + "img/course-appetizer.e6a797acfad36ae367d8a9ccede26e46.png";